<h1>{{ title }}</h1>
<ng-content></ng-content>
